import {
  IconAlertCircle,
  IconLayersIntersect,
  IconPackage,
  IconUsers,
} from "@tabler/icons-react";

const ProductCard = ({
  props,
  onClick,
}: {
  props?: any;
  onClick?: () => void;
}) => {
  const {
    name = "",
    material = "",
    inventoryLowerLimit = "",
    partner = null,
  } = props || {};

  return (
    <div
      className="cursor-pointer rounded-xl border border-gray-200 bg-white p-5 shadow-sm transition-shadow hover:shadow-md"
      onClick={onClick}
    >
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
          <IconPackage size={20} />
        </div>
        <div
          className="truncate text-lg font-semibold"
          style={{ color: "#6F6F6F" }}
        >
          {name || "—"}
        </div>
      </div>
      <div className="mt-4 space-y-2 text-sm text-gray-600">
        {partner?.name ? (
          <div className="flex items-center gap-2">
            <IconUsers size={15} className="text-gray-400" />
            <span className="truncate">{partner.name}</span>
          </div>
        ) : null}
        {material ? (
          <div className="flex items-center gap-2">
            <IconLayersIntersect size={15} className="text-gray-400" />
            <span className="truncate">{material}</span>
          </div>
        ) : null}
        {inventoryLowerLimit !== "" && inventoryLowerLimit != null ? (
          <div className="flex items-center gap-2">
            <IconAlertCircle size={15} className="text-gray-400" />
            <span className="truncate">{inventoryLowerLimit}</span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ProductCard;
